{
  "editDialog": {
    "titleNew": "New employee",
    "titleEdit": "Edit employee — PIN {{pin}}",
    "pinLabel": "Device User ID (PIN)",
    "nameLabel": "Full name",
    "roleLabel": "Role",
    "cardLabel": "Card number",
    "payRates": {
      "legend": "Pay rates (AMD)",
      "hourlyRate": "Hourly rate (AMD/h)",
      "monthlySalary": "Monthly salary (AMD)",
      "afterHoursRate": "After-hours rate (AMD/h)",
      "explainer": "Hourly rate is used for attendance-based pay. Monthly salary is divided proportionally across working days. After-hours rate covers overtime hours.",
      "unitPerHour": "AMD/h",
      "unitMonthly": "AMD"
    },
    "workHours": {
      "legend": "Work hours",
      "startLabel": "Day start",
      "endLabel": "Day end",
      "explainer": "Optional per-employee work-day start and end. Leave empty to use the company-wide schedule. A changed window applies from today unless an effective date is set — past days keep the schedule they were worked under.",
      "attendanceExemptLabel": "Present by default (freeform visits)",
      "attendanceExemptHint": "No lateness, early-leave, overtime or absence deductions; the timesheet marks working days as present even without check-ins.",
      "effectiveFromLabel": "Effective from",
      "daysPerWeekLabel": "Working days per week",
      "daysPerWeekCompany": "Company schedule",
      "daysPerWeekHint": "E.g. 6 when the employee has one floating day off per week — it is credited automatically.",
      "restWeekdaysLabel": "Personal rest days",
      "restWeekdaysHint": "This employee's fixed weekly days off. Selected days show as X in their timesheet, carry no deduction and drop out of the salary divisor. Select none to follow the company schedule.",
      "days": {
        "mon": "Mon",
        "tue": "Tue",
        "wed": "Wed",
        "thu": "Thu",
        "fri": "Fri",
        "sat": "Sat",
        "sun": "Sun"
      }
    },
    "dates": {
      "legend": "Hiring & termination dates",
      "hiredLabel": "First work day",
      "registeredLabel": "Registered in company",
      "terminatedLabel": "Termination date",
      "explainer": "These dates feed the \"Hiring\" report: hiring start, registration start and end."
    },
    "vacation": {
      "legend": "Vacation",
      "carryoverLabel": "Days carried over from previous years",
      "explainer": "Unused vacation days from before this year (e.g. from the old spreadsheet). Added to the annual 20-day allowance in the Time Off table. Fractional and negative values are allowed."
    },
    "activeLabel": "Active",
    "saveFailed": "Save failed",
    "pushNotice": "A push command will be sent to the terminal after saving.",
    "autoSyncNotice": "Changes will be pushed to the terminal automatically.",
    "contact": {
      "legend": "Personal & contact",
      "birthDateLabel": "Date of birth",
      "phoneLabel": "Phone",
      "emailLabel": "Email"
    }
  },
  "entriesExits": {
    "title": "Entries/Exits",
    "exportCsv": "Export CSV",
    "failedToLoad": "Failed to load data. Please refresh the page.",
    "noRecords": "No records for the selected period",
    "noRecordsHint": "Adjust the filters or wait for device data to arrive",
    "filters": {
      "type": "Type",
      "allTypes": "— all —"
    },
    "eventTypes": {
      "entry": "Clock in",
      "exit": "Clock out",
      "breakOut": "Break start",
      "breakReturn": "Break end",
      "overtimeIn": "Overtime-In",
      "overtimeOut": "Overtime-Out"
    },
    "verifyModes": {
      "password": "Password",
      "fingerprint": "Fingerprint",
      "card": "Card",
      "passwordFingerprint": "Password+Fingerprint",
      "passwordCard": "Password+Card",
      "face": "Face",
      "modeN": "Mode {{n}}"
    },
    "columns": {
      "timestamp": "Timestamp",
      "employee": "Employee",
      "type": "Type",
      "verifyMethod": "Verify Method"
    },
    "manual": {
      "addButton": "Add record",
      "title": "Add manual record",
      "subtitle": "For when an employee forgot to punch at the terminal.",
      "employeeLabel": "Employee",
      "employeePlaceholder": "Select employee…",
      "dateLabel": "Date",
      "timeLabel": "Time",
      "noteLabel": "Note (optional)",
      "notePlaceholder": "e.g. forgot to punch in",
      "badge": "Manual",
      "confirmDelete": "Delete this record for {{name}}?",
      "errors": {
        "employeeRequired": "Select an employee.",
        "dateRequired": "Select a date.",
        "timeRequired": "Enter a time."
      },
      "toasts": {
        "created": "Record added.",
        "createFailed": "Failed to add the record.",
        "duplicate": "A record for this employee at this time already exists.",
        "deleted": "Record deleted.",
        "deleteFailed": "Failed to delete the record."
      }
    }
  },
  "profile": {
    "back": "Employees",
    "failedToLoad": "Failed to load the employee.",
    "fields": {
      "birthDate": "Date of birth",
      "phone": "Phone",
      "email": "Email"
    },
    "documents": {
      "title": "Documents",
      "hint": "Passport scans, contracts and other files. PDF, images, Word/Excel — up to 15 MB.",
      "upload": "Upload document",
      "uploading": "Uploading…",
      "empty": "No documents uploaded yet.",
      "downloadAria": "Download document",
      "deleteAria": "Delete document",
      "toasts": {
        "uploaded": "Document uploaded.",
        "uploadFailed": "Failed to upload the document. Please try again.",
        "deleted": "Document deleted.",
        "deleteFailed": "Failed to delete the document. Please try again.",
        "downloadFailed": "Failed to download the document. Please try again."
      }
    },
    "details": {
      "title": "Details",
      "work": "Work & dates",
      "workHours": "Work hours",
      "companySchedule": "Company schedule",
      "terminals": "Terminals & biometrics",
      "devices": "Terminals",
      "biometrics": "Biometrics",
      "pay": "Pay",
      "hourlyRate": "Hourly rate",
      "monthlySalary": "Monthly salary",
      "overtimeRate": "Overtime rate",
      "carryover": "Vacation carryover",
      "daysUnit": "days",
      "biometricKinds": {
        "face": "Face",
        "fp": "Fingerprint",
        "palm": "Palm"
      }
    },
    "photo": {
      "changeAria": "Change photo",
      "removeAria": "Remove photo",
      "hint": "JPEG, PNG or WebP — up to 10 MB.",
      "toasts": {
        "uploaded": "Photo updated.",
        "uploadFailed": "Failed to upload the photo. Please try again.",
        "removed": "Photo removed.",
        "removeFailed": "Failed to remove the photo. Please try again."
      }
    }
  }
}
